import uuid from 'uuid';
import { Food } from '../model/food.model';
import { menuFactory } from '../factory/menu.factory';
import {removeDay} from '../services/RemoveMenuDay';
import { checkDay, checkPlan, checkRepeated, removeRepetition } from '../services/AnalizeRepeatedFoods';
import { multiPortionFoodsManager } from "../services/MultiPortionFoodsManager";

export const SET_DICTIONARIES = 'SET_DICTIONARIES';
export const SET_USER = 'SET_USER';
export const SET_COUNTRIES = 'SET_COUNTRIES';

export default {
  setSettings: (state, response) => {
    state.settings = response.data;
  },
  setConfiguration: (state, response) => {
    state.configuration = response.configuration;
  },
  setMenu: (state, response) => {
    state.menu = menuFactory.create(response.menu);
  },
  addMeal: (state, payload) => {
    const { dayId, planId, mealDTO } = payload;

    const plan = state.menu.schema.days.find(d => d.id === dayId).getPlan(planId);

    plan.addMeal(new Food(
      uuid(),
      mealDTO.name,
      mealDTO.kcal,
      mealDTO.nutrients,
    ));
  },
  removeFood: (state, payload) => {
    const { dayId, planId, foodId } = payload;

    const plan = state.menu.schema.days.find(d => d.id === dayId).getPlan(planId);

    const food = plan.getFood(foodId);

    if (food.isMultiPortionFood()) {
      multiPortionFoodsManager.removeMultiPortionFood(food, state.menu.schema);
    }

    plan.removeFood(foodId);
  },
  removeProduct: (state, payload) => {
    const { dayId, planId, productId } = payload;

    const plan = state.menu.schema.days.find(d => d.id === dayId).getPlan(planId);

    plan.removeProduct(productId);
  },

  removePlan: (state, payload) => {
    const { dayId, planId } = payload;
    state.menu.schema.days.find(d => d.id === dayId).removePlan(planId);
  },

  showModal: (state, payload) => {
    const { component, data, options } = payload;
    state.modal.visible = true;
    state.modal.component = component;
    state.modal.data = data;
    state.modal.options = options;

    state.modals.push({
      data: data,
      options: options,
      component: component,
    });

    jQuery('body').addClass('modal-open');
  },
  hideModal(state) {
    state.modal.data = null;
    state.modal.options = null;
    state.modal.visible = false;
    state.modal.component = 'empty';

    state.modals = [];

    jQuery('body').removeClass('modal-open');
  },

  addDay: (state, payload) => {
    state.menu.schema.days.push(payload);
  },

  removeDay: (state, id) => {
    const day = state.menu.schema.getDay(id);
    removeDay(state.menu.schema, id);
    checkDay(state.menu.schema, day);
  },

  checkDayRepetition: (state, day) => {
    checkDay(state.menu.schema, day);
  },

  checkFoodRepetition: (state, food) => {
    checkRepeated(state.menu.schema, food);
  },

  checkPlanRepetition: (state, plan) => {
    checkPlan(state.menu.schema, plan);
  },

  removeDateRepetition: (state, food) => {
    removeRepetition(state.menu.schema, food);
  },

  toggleComments: (state, commentsHidden) => {
    state.commentsHidden = commentsHidden;
  },

  resetProductReplacements: (state) => {
    state.productReplacements = [];
  },

  addProductReplacement: (state, productReplacement) => {
    state.productReplacements.push(productReplacement);
  },

  resetFoodsWithReplacements: (state) => {
    state.foodsWithReplacements = [];
  },

  addFoodWithReplacements: (state, foodWithReplacement) => {
    state.foodsWithReplacements.push(foodWithReplacement);
  },

  removeProductReplacement: (state, product) => {
    state.productReplacements = state.productReplacements.filter((productReplacement) => {
      return productReplacement.id !== product.id;
    });
  },

  removeFoodWithReplacement: (state, food) => {
    state.foodsWithReplacements = state.foodsWithReplacements.filter((foodWithReplacement) => {
      return foodWithReplacement.id !== food.id;
    });
  },

  setProductsReplaced: (state, productsReplaced) => {
    state.productsReplaced = productsReplaced;
  },

  resetFoodsWithSearchedProduct: (state) => {
    state.foodsWithSearchedProduct = [];
  },

  resetProductsSameAsSearchedProduct: (state) => {
    state.productsSameAsSearchedProduct = [];
  },

  updateFoodsWithSearchedProduct: (state, food) => {
    state.foodsWithSearchedProduct.push(food);
  },

  updateProductsSameAsSearchedProduct: (state, product) => {
    state.productsSameAsSearchedProduct.push(product);
  },

  toggleDragAndCopy: (state, enabled) => {
    state.dragAndCopyEnabled = enabled;
  },

  setSentToMobileAppAt: (state, sentToMobileAppAt) => {
    state.sentToMobileAppAt = sentToMobileAppAt;
  },

  [SET_DICTIONARIES](state, dictionaries) {
    state.dictionaries = dictionaries;
  },

  [SET_USER](state, user) {
    state.user = user;
  },
  [SET_COUNTRIES](state, countries) {
    state.countries = countries;
  },
};
